import { BigNumber } from '@ethersproject/bignumber';

import { bn, humanizeBn } from 'tools/math';

import { TransferRecipient } from './transferWizard.store';

export const amountToWei = (amount: string, decimals: number): BigNumber => {
  if (!amount) return BigNumber.from(0);
  return bn(amount, decimals);
};

export const weiToAmount = (value: BigNumber, decimals: number): string => {
  // Use humanizeBn which already trims trailing zeros
  return humanizeBn(value, decimals);
};

export const sumRecipientsWei = (recipients: TransferRecipient[], decimals: number): BigNumber => {
  return recipients.reduce(
    (acc, recipient) => acc.add(amountToWei(recipient.amount, decimals)),
    BigNumber.from(0),
  );
};

export const allocateEvenly = (
  totalAmount: string,
  recipients: TransferRecipient[],
  decimals: number,
): TransferRecipient[] => {
  if (!recipients.length) return recipients;

  const totalWei = amountToWei(totalAmount, decimals);

  if (totalWei.isZero()) {
    return recipients.map(recipient => ({ ...recipient, amount: '' }));
  }

  const count = BigNumber.from(recipients.length);
  const base = totalWei.div(count);
  const remainder = totalWei.mod(count);
  const remainderCount = remainder.toNumber();

  return recipients.map((recipient, index) => {
    const shareWei = index < remainderCount ? base.add(1) : base;
    return {
      ...recipient,
      amount: weiToAmount(shareWei, decimals),
    };
  });
};

export const updateRecipientAmount = (
  recipients: TransferRecipient[],
  walletId: number,
  amount: string,
): TransferRecipient[] =>
  recipients.map(recipient =>
    recipient.walletId === walletId ? { ...recipient, amount } : recipient,
  );
